@let site = site$ | async;
@defer (when site) {
    <div class="flex flex-col">
        <h5>Payment Options</h5>
        @let isAnyOptionSelected = isAnyOptionSelected$.source$ | async;
        <div [class.hidden]="elevatedAccess() || isAnyOptionSelected">No payment option selected</div>

        @if (mode() === 'edit') {
            <medpace-form-errors [formControlWithErrors]="formGrp()" [style]="'alert'" />
        }

        @if (elevatedAccess() || site.payment.credit) {
            <mds-checkbox
                id="prePaidDebitCardCheckbox"
                [formCtrl]="formGrp().controls.prePaidDebitCardControl"
                [label]="'Pre-Paid Debit Card'"
                name="credit"
            />
        }

        @if (elevatedAccess() || site.payment.check) {
            <mds-checkbox
                id="checkCheckbox"
                [formCtrl]="formGrp().controls.checkControl"
                [label]="'Check'"
                name="check"
            />
        }

        @if (elevatedAccess() || site.payment.wireTransfer) {
            <mds-checkbox
                id="wireTransferCheckbox"
                [formCtrl]="formGrp().controls.wireTransferControl"
                [label]="'Wire Transfer'"
                name="wireTransfer"
            />
        }

        @let wireTransfer = wireTransfer$.source$ | async;
        <mds-checkbox
            [class.hidden]="!wireTransfer"
            class="ml-4"
            id="collectBankDetailsCheckbox"
            [formCtrl]="formGrp().controls.collectBankDetailsControl"
            [label]="'Enable collection of patient bank details?'"
            name="collectBankDetails"
        />

        @if (elevatedAccess() || site.payment.reimburse) {
            <mds-checkbox
                id="reimburseCheckbox"
                [formCtrl]="formGrp().controls.reimburseControl"
                [label]="'Site will reimburse patient directly - Medpace to reimburse site'"
                name="reimburse"
            />
        }

        @if (elevatedAccess() || site.payment.payQuicker) {
            <mds-checkbox
                id="payQuickerCheckbox"
                [formCtrl]="formGrp().controls.payQuickerControl"
                [label]="'PayQuicker'"
                name="payQuicker"
                [matTooltip]="payQuickerTooltip()"
                [matTooltipPosition]="'left'"
            />
        }
    </div>
}
